export const HOUR_MS = 3_600_000;

/** Start of the hour bucket `offset` hours after the current hour. Matches
 *  TimelineScrubber, whose T+0 is the current hour floored. */
export function hourStart(nowMs: number, offset: number): number {
  return Math.floor(nowMs / HOUR_MS) * HOUR_MS + offset * HOUR_MS;
}

/** Window [start, end) overlaps bucket [h0, h0 + 1 h). */
export function overlapsHour(
  startUtc: string,
  endUtc: string,
  offset: number,
  nowMs: number,
): boolean {
  const start = Date.parse(startUtc);
  const end = Date.parse(endUtc);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
  const h0 = hourStart(nowMs, offset);
  return start < h0 + HOUR_MS && end > h0;
}

/** ENG-191 — an OI whose window hasn't opened yet. */
export function isFutureOi(startUtc: string | null | undefined, nowMs: number): boolean {
  const start = startUtc ? Date.parse(startUtc) : Number.NaN;
  return Number.isFinite(start) && start > nowMs;
}
